import styled, { css } from 'styled-components'

import {
  DeprecatedText,
  TypeStyle,
  TypeStyleCssFunctionProps,
  fromMd,
  untilMd,
} from '@syconium/little-miss-figgy'

import { DetailsSectionSidePaddedSection } from '../styles'

import { BadgesSection as BaseBadgesSection } from './BadgesSection'

export const Container = styled.div``

export const BadgesSectionContainer = styled(DetailsSectionSidePaddedSection)``

export const Description = styled(DeprecatedText)`
  line-height: 20px;
  padding: 0 24px;

  ${fromMd} {
    padding: 0;
  }
`

export const MarkedDownPrice = styled.span<TypeStyleCssFunctionProps>`
  ${TypeStyle.css.bodyDefault};
  color: ${o => o.theme.color.deprecated.red.dark};
  font-weight: bold;
  font-size: 16px;

  ${fromMd} {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: ${o => (o.$isUppercase ? '0.15em' : '0.05em')};
    line-height: 1.5;
  }
`

export const PriceDetails = styled.div`
  display: flex;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.05em;
  line-height: 1.7;
  margin-bottom: ${o => o.theme.spacing(2)};
  margin-top: ${o => o.theme.spacing(2)};
  column-gap: ${o => o.theme.spacing(2)};
  flex-wrap: wrap;

  ${untilMd} {
    margin-inline-start: ${o => o.theme.dimensions.layout.sidePadding.md}px;
  }

  ${fromMd} {
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    margin-bottom: 4px;
  }

  > * {
    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: auto;
  }
`

export const Price = styled.span<{
  styleAsMarkedDownPrice?: boolean
}>`
  ${fromMd} {
    font-size: 18px;
    font-weight: bold;
    line-height: 1.5;
  }

  ${o => css`
    ${o.styleAsMarkedDownPrice && TypeStyle.css.bodyLarge};
    color: ${o.styleAsMarkedDownPrice
      ? o.theme.color.deprecated.obsidianLighter
      : o.theme.color.deprecated.obsidianLight};
    font-weight: bold;
    text-decoration: ${o.styleAsMarkedDownPrice ? 'line-through' : 'none'};
  `}
`

export const BadgesSection = styled(BaseBadgesSection)`
  padding-left: 0;
  align-self: center;
`

export const ErrorMessageContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)};

  ${untilMd} {
    margin-top: ${({ theme }) => theme.spacing(4)};
    padding: ${({ theme }) => theme.spacing(0, 4, 0)};
  }
`
